import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OverrideService } from '../../../../@shelter/utils/override.service';
import { UserService } from '../../../core/user/user.service';
import { GenericData } from '../interfaces/all-generic';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'control-design',
    templateUrl: './control-generic.component.html',
    styleUrls: ['./control-generic.component.scss'],
})
export class ControlGenericComponent implements OnInit {
    @Input() data: GenericData;
    BaseRoute: any;

    constructor(
        public override: OverrideService,
        private router: Router,
        private _httpClient: HttpClient,
        private route: ActivatedRoute,
        private userService: UserService,
        private snackBar: MatSnackBar
    ) {}
    ngOnInit(): void {
        this.BaseRoute = this.data.route;
    }

    public get isEdit(): boolean {
        return this.route.snapshot.paramMap.has('id');
    }

    async save() {
        if (this.data.onSaveClick) {
            this.data.onSaveClick(this.data.form).subscribe(
                (res) => {
                    if (res) {
                        if (this.data.title.single === 'Chart') {
                            return this.router.navigate([
                                this.data.route[0],
                                res['_id'],
                            ]);
                        }
                        this.snackBar.open('Save successfully', 'close', {
                            duration: 3000,
                        });
                        return this.router.navigate(this.data.route);
                    }
                },
                (err) => {
                    this.snackBar.open(err?.error?.message, 'close', {
                        duration: 3000,
                    });
                }
            );
        } else {
            this._httpClient
                .post(`${this.data.apiUrls.post}`, this.data.form.value)
                .subscribe((res) => {
                    this.router.navigate(this.data.route);
                });
        }
    }
    cancel() {
        this.router.navigate(this.data.route);
    }
}
